export default "__VITE_ASSET__ff76a57d__"